// axios 统一请求层:后端约定 Authorization: Bearer {token} 校验登录态
// 响应统一为 { code, msg, data },code=200 时直接取 data
// 401 未登录/过期 -> 清除登录态并跳转登录页;403 无权限 -> 提示
import axios from 'axios'
import { ElMessage } from 'element-plus'
import { getToken, clearAuth } from './auth'

const request = axios.create({
  baseURL: '/api',
  timeout: 10000
})

// 请求拦截:携带 token
request.interceptors.request.use(config => {
  const token = getToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// 响应拦截:剥离统一响应结构 + 登录态失效处理
request.interceptors.response.use(
  res => {
    const { code, msg, data } = res.data
    if (code === 200) {
      return data
    }
    if (code === 401) {
      clearAuth()
      ElMessage.error(msg || '登录已过期,请重新登录')
      window.location.hash = '#/login'
      return Promise.reject(new Error(msg || '未登录'))
    }
    ElMessage.error(msg || '操作失败')
    return Promise.reject(new Error(msg || '操作失败'))
  },
  err => {
    ElMessage.error(err.message || '网络异常,请稍后重试')
    return Promise.reject(err)
  }
)

export default request
